import { configureStore } from '@reduxjs/toolkit'
import authenticationReactiveReducer from './domains/auth/redux/authenticationReactive'


export default configureStore({
  reducer: {
    auth: authenticationReactiveReducer
  },
})